<template>
  <form class="auth-form" @submit.prevent="loginHandler">
    <div class="auth-form__content">
      <div class="auth-form__content-container">
        <input
          type="email"
          placeholder="Логин"
          v-model.trim="auth.login"
          :class="[
            'auth-form__input',
            {
              invalid:
                ($v.auth.login.$dirty && !$v.auth.login.required) ||
                ($v.auth.login.$dirty && !$v.auth.login.email),
            },
          ]"
        />
        <div
          class="error"
          v-if="!$v.auth.login.$dirty && !$v.auth.login.required"
        >
          Поле "Логин" обязательно к заполнению.
        </div>
      </div>
      <div class="auth-form__content-container">
        <input
          :class="[
            'auth-form__input',
            {
              invalid:
                ($v.auth.login.$dirty && !$v.auth.pass.required) ||
                ($v.auth.login.$dirty && !$v.auth.pass.minLength),
            },
          ]"
          type="password"
          placeholder="Пароль"
          v-model.trim="auth.password"
        />
        <div
          class="error"
          v-if="!$v.auth.password.$dirty && !$v.auth.password.required"
        >
          Поле "Пароль" обязательно к заполнению.
        </div>
        <div
          class="error"
          v-if="!$v.auth.password.email && !$v.auth.password.minLength"
        >
          Минимальная длина пароля 6 символов
        </div>
      </div>
    </div>
    <button class="auth-form__btn button-main">Войти</button>
  </form>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      auth: {
        login: "",
        password: "",
      },
      accept: "",
    };
  },
  mixins: [validationMixin],

  methods: {
    fetchData() {
      return this.$store.dispatch("authModule/getAuthUserData");
    },

    fetchAwardsList() {
      return this.$store.dispatch("awardsModule/fetchAwardsList", {
        onlyAccepted: false,
        from: null,
        to: null,
        isHr: false,
      });
    },
    loginHandler() {
      this.$store
        .dispatch("authModule/onLogin", {
          login: this.auth.login,
          password: this.auth.password,
          accept: this.accept,
        })
        .then(res => {
          localStorage.setItem("price-list", JSON.stringify({ name: "" }));
          localStorage.setItem("bazis-data", JSON.stringify({ name: "" }));
          localStorage.setItem("discount", JSON.stringify({ name: "" }));
          localStorage.setItem("post", JSON.stringify({ name: "" }));
          this.fetchData().then(() => {
            const userRole = this.$store.getters["authModule/getUserRole"];
            console.log(userRole);
            this.$store.commit("ordersModule/setUserRole", userRole);
            if (userRole === "hr") {
              this.$router.push("/newbie-awards");
            } else if (userRole === "director") {
              this.$router.push("/statistic/top-digest");
              this.fetchAwardsList();
            } else {
              this.$router.push("/orders");
            }
          });
        })
        .catch(() => {
          alert("Что-то пошло не так");
        });
    },
  },

  validations() {
    return {
      auth: {
        login: { required },
        password: { required, minLength: minLength(6) },
      },
    };
  },
  mounted() {
    if (window.location.search === "?accept=1") {
      this.accept = "?accept=1";
    }
  },
};
</script>
